import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
@Component({
  selector: 'app-brand-comparison',
  templateUrl: './brand-comparison.component.html',
  styleUrls: ['./brand-comparison.component.scss']
})
export class BrandComparison implements OnInit {

  @Input() dataReport: any

  title_report = 'So sánh thương hiệu';
  content = "";
  brandDiscuss = Array();
  public barChartOptions = {
    plugins: {
      labels: {
        render: 'value',
        fontColor: 'black',
        precision: 2,
        arc: true,
        fontSize: 15,
        fontStyle: 'bold'
      }
    }
  };
  public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData = [
    // { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    // { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];
  public barChartColors: Color[] = [
    { backgroundColor: '#00b0f0' },
    { backgroundColor: '#c10e45' }
  ]

  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
  }

  async mappingData() {
    if (this.dataReport && this.dataReport.data) {
      if (this.dataReport && this.dataReport.data) {
        if (this.dataReport.report_title) {
          this.title_report = this.dataReport.report_title;
        }

        this.barChartLabels = [];

        // dữ liệu bar chart
        let objComment = {
          label: 'Bình luận',
          data: []
        }
        let objPost = {
          label: 'Bài đăng',
          data: []
        }
        this.barChartLabels.push(this.dataReport.data.brandMain.name);
        objComment.data.push(this.dataReport.data.brandMain.comment);
        objPost.data.push(this.dataReport.data.brandMain.post);
        this.brandDiscuss=this.dataReport.data.brandDiscusss.slice();
        this.dataReport.data.brandDiscusss.forEach(item => {

          this.barChartLabels.push(item.name);
          objComment.data.push(item.comment);
          objPost.data.push(item.post)
        });
        this.barChartData = [
          objPost,
          objComment
        ];
        // end dữ liệu barcharrt
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/brand-comparison/brand-comparison.component.ts